import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import { connect } from 'react-redux';
import CardWidget from "../card-widget/CardWidget";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import CardWidgetNewPasswordInput from "../card-widget/CardWidgetNewPasswordInput";
import Api from "../../services/api/Api";
import {ApiPaths} from "../../services/api/ApiPaths";
import {RouteConstants} from "../route/services/RouteConstants";
import {PASSWORD_RESET_STATUS} from "./PasswordResetStatus";
import {getLanguage} from "../../store/rootReducer";

class PasswordResetForm extends Component {

  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      password: "",
      errorMessage: null,
      isStrongPassword: false,
      username: null
    };
  }

  submitPassword = () => {
    let request = {
      "passwordResetToken": this.props.passwordResetToken,
      "password": this.state.password,
      "lang": this.props.language
    };
    Api.post(ApiPaths.PASSWORD_RESET, request).then(
        (response) => {
          if (response.data.status === PASSWORD_RESET_STATUS.SUCCESS) {
            this.props.history.push(RouteConstants.LOGIN);
          } else if (response.data.status === PASSWORD_RESET_STATUS.INVALID_TOKEN) {
            this.props.history.push(RouteConstants.PASSWORD_RESET_ERROR);
          } else {
            this.setState({
              errorMessage: "common.general_processing_error"
            });
          }
        },
        (error) => {
          this.setState({
            errorMessage: "common.general_processing_error"
          });
        });
  };

  onPasswordChanged = (password, isStrongPassword) => {
    this.setState(
        {
          password: password,
          isStrongPassword: isStrongPassword
        }
    );
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.isStrongPassword) {
      this.submitPassword();
    }
  };

  getCardContent = () => {
    return (
        <form onSubmit={(e) => this.handleSubmit(e)}>
          <CardWidgetContent contentText="password_reset.password_reset_instructions"/>
          <CardWidgetErrorsContainer errorMessage={this.state.errorMessage}/>
          <CardWidgetNewPasswordInput fieldLabel="password_reset.password_field_label"
                                      onChange={this.onPasswordChanged}/>
        </form>
    )
  };

  render() {
    return (
        <CardWidget getCardContent={this.getCardContent}
                    isSubmitDisabled={!this.state.isStrongPassword}
                    submitButtonAction={() => this.submitPassword()}
                    submitButtonText="forgotpassword.next"/>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

PasswordResetForm.propTypes = {
  passwordResetToken: PropTypes.string
};

export default connect(mapStateToProps)(PasswordResetForm);